exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-03b27361]{width:100%;height:100px}.share-type[data-v-03b27361]{margin-bottom:12px}label[data-v-03b27361]{font-weight:bold}.content[data-v-03b27361]{width:420px}.auth-note[data-v-03b27361]{margin-top:8px}", ""]);

// exports
